import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

/**
 * Ensures that the histology type is empty when its flag is false.
 * If a type is provided while the flag is not selected, the validator returns an error.
 * @param flagField Name of the boolean flag control
 * @param typeField Name of the histology type control
 */
export function tumorHistologyValidator(flagField: string, typeField: string): ValidatorFn {
  return (group: AbstractControl): ValidationErrors | null => {
    const flag = group.get(flagField);
    const type = group.get(typeField);

    if (!flag || !type) return null;

    const flagValue = flag.value;
    const typeValue = type.value;

    // clear previous error first
    if (type.hasError("mustBeEmpty")) {
      const errors = { ...type.errors };
      delete errors["mustBeEmpty"];
      type.setErrors(Object.keys(errors).length ? errors : null);
    }

    if (!flagValue && typeValue) {
      type.setErrors({ ...(type.errors || {}), mustBeEmpty: true });
    }

    return null;
  };
}
